export const RulesRoutes = {
    TestAiPrompt: "Rule/TestAiPrompt",
    GetRuleConfig: "Rule/GetRuleConfig",
    GetRuleCollectionAiPrompt: "Rule/GetRuleCollectionAiPrompt",
    SaveRuleConfig: "Rule/SaveRuleConfig",
    GetRiskCategorySettings: "Rule/GetRiskCategorySettings",
    SaveRiskCategorySettings: "Rule/SaveRiskCategorySettings",
    AssignRuleCollections: "Rule/AssignRuleCollections",
    EntityMetaData: "Rule/EntityMetaData",
    GetRuleCollectionAssignments: "Rule/GetRuleCollectionAssignments",
    ReorderBusinessUnitRules: "Rule/ReorderBusinessUnitRules",
    GetAdvancedParameterValue: "Rule/GetAdvancedParameterValue",
    GetAdvancedParameterDisplayText: "Rule/GetAdvancedParameterDisplayText",
    SetVettingCommentAction: "Rule/SetVettingCommentAction",
    DeleteRules: "Rule/DeleteRules",
    OverrideVettingAction: "Rule/OverrideVettingAction",
    OverrideVettingRisk: "Rule/OverrideVettingRisk",
    GetRuleConfigs: "Rule/GetRuleConfigs",
    GetRuleCollection: "Rule/GetRuleCollection",
    GetRuleCollectionDisplayName: "Rule/GetRuleCollectionDisplayName",
    DeleteRuleCollections: "Rule/DeleteRuleCollections",
    SaveRuleCollection: "Rule/SaveRuleCollection",
    SaveRuleCollectionAiPrompt: "Rule/SaveRuleCollectionAiPrompt",
    GetRuleCollections: "Rule/GetRuleCollections",
    GetAvailableRuleCollections: "Rule/GetAvailableRuleCollections",
    GetBuRuleCollections: "Rule/GetBuRuleCollections",
    AssignBuRuleCollections: "Rule/AssignBuRuleCollections",
    GetRuleCollectionsForRule: "Rule/GetRuleCollectionsForRule",
    AssignRuleCollectionsToRule: "Rule/AssignRuleCollectionsToRule",
    SaveRuleCollectionRightStoreSetup: "Rule/SaveRuleCollectionRightStoreSetup",
    GetRuleCollectionRightStoreSetup: "Rule/GetRuleCollectionRightStoreSetup",
    GetRuleCollectionRightStoreSetups: "Rule/GetRuleCollectionRightStoreSetups"
}